<template>
  <div class="od-card-container margin-bottom-8">
    <div class="odc-body-container">
      <div
        v-if="totalMonitoring"
        class="flex-row align-center just-between"
      >
        <div class="total-title">
          {{ `Total Monitoring ${order.contractPeriod} months` }}
        </div>
        <div>
          {{ getAmount(totalMonitoring) }}
        </div>
      </div>
      <div
        v-if="totalMonitoring"
        class="flex-row align-center just-between"
      >
        <div class="sub-title">
          Next payment in {{ order.deploymentPeriod }} days (<b>{{ nextPaymentDate }}</b>)
        </div>
      </div>
      <div class="flex-row align-center just-between">
        <div class="total-title">
          SubTotal
        </div>
        <div>
          {{ getAmount(order.orderTotal) }}
        </div>
      </div>
      <div class="flex-row align-center just-between">
        <div class="total-title">
          Tax
        </div>
        <div>
          {{ getAmount(prTaxTotal) }}
        </div>
      </div>
      <div class="flex-row align-center just-between">
        <div class="total-title">
          Total
        </div>
        <div>
          {{ getAmount(prOrderTotal) }}
        </div>
      </div>
    </div>
    <div
      v-if="!paymentPending"
      class="odc-paid"
    >
      PAID
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'OrderTotal',
  mixins: [partnerReviewMixin],
  computed: {
    totalMonitoring() {
      const subscription = this.order.orderLines.find((ol) => ol.type.toLowerCase() === 'subscription');
      if (subscription) {
        return this.order.contractPeriod * subscription.total;
      }
      return 0;
    },
    nextPaymentDate() {
      const subscription = this.order.orderLines.find((ol) => ol.type.toLowerCase() === 'subscription');
      if (subscription) {
        const paymentDate = moment(this.order.orderDate).add(this.order.deploymentPeriod, 'days');
        let format = 'MMM Do';
        if (paymentDate.year() !== moment().year()) {
          format = 'MMM Do YYYY';
        }
        return paymentDate.format(format);
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>

.total-title {
  font-size: 1.100rem;
  font-weight: 500;
}
.sub-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: $N60;
  margin-top: -4px;
}
.odc-paid {
  background-color: $SEAFOAM;
  padding: 6px;
  text-align: center;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
</style>
